import { googleLogout } from '@react-oauth/google'
import { deleteSession } from './deleteSession'

export function logout() {
  googleLogout()
  deleteSession()
  localStorage.removeItem('TD-AgentRole')
  localStorage.removeItem('td-credential')
  localStorage.removeItem('TD-userID')
  localStorage.removeItem('role')
  localStorage.removeItem('TD-ModuleManagerToken')
  localStorage.removeItem('TD-ModuleManagerTokenType')
  localStorage.removeItem('TD-ModuleManagerPermissions')
}
